export default "./../images/attachment.svg";